import React from 'react'
import {useQueryParam} from "../routerHooks";
import {TeamSchedule} from "../team-home-page/pages/TeamSchedule";
import {useBodyColor} from "../hooks";
import MobilePage from "../components/MobilePage";


const TeamSchedulePage = ({ teamId }) => {
  useBodyColor('#ECF7FE')

  return (
    <MobilePage maxWidth={1200} wrapContentInCards={false}>
      <TeamSchedule teamId={teamId} />
    </MobilePage>
  )
}

export default () => {
  const [teamId] = useQueryParam('teamId')

  return <TeamSchedulePage teamId={parseInt(teamId)} />
}
